class AssessmentService {
    constructor($http, initConfigProvider, securityService) {
        this.http = $http;
        this.apiPath = initConfigProvider.apiBaseUrl + initConfigProvider.disclosureServiceEndPoint;
        this.securityService = securityService;
        this.callApi = (routePart, httpMethod, acceptCode, data) => {
            let curtinId = this.securityService.getAutheticatedUserId();

            return httpMethod(`${this.apiPath}/${routePart}`, data).then((response) => {
                if (response.status === acceptCode) {
                    return {
                        data: response.data,
                        error: ''
                    };
                } else if (response.data && response.data.error) {
                    return {
                        data: null,
                        error: response.data.error
                    };
                } 
                return {
                    data: null,
                    error: 'User service error'
                };
            }).catch((error) => {
                console.log(error);
                return {
                    data: null,
                    error: 'User service error'
                };
            });
        };
    }

    requestInfo(requestInfoDto) {
        let routePart = `${requestInfoDto.disclosureId}/requestinformation`;
        return this.callApi(routePart, this.http.patch, 204, requestInfoDto);
    }

    submitAssessment(assessmentDto) {
        let routePart = `${assessmentDto.disclosureId}/submitassessment`;
        return this.callApi(routePart, this.http.patch, 204, assessmentDto);
    }
}

AssessmentService.$inject = ['$http', 'initConfigProvider', 'securityService'];

export default AssessmentService;


// WEBPACK FOOTER //
// ./app/services/assessment.service.js